/**
 * Валидация кандидатов перед добавлением в рассылку.
 * Телефон НЕ обязателен — основной канал мессенджер HH (TASKNEIROKLYUCH-530).
 */

export interface MailingCandidate {
  id?: string | null;
  phone?: string | null;
  email?: string | null;
  telegram?: string | null;
  whatsapp?: string | null;
  max?: string | null;
}

/**
 * Проверяет, можно ли добавить кандидата в рассылку.
 * - HH: достаточно resumeId (мессенджер HH работает без телефона)
 * - E-Staff/Skillaz: нужен id или хотя бы один контакт
 */
export function isValidForMailing(candidate: MailingCandidate, isHH: boolean): boolean {
  if (isHH) {
    return !!candidate.id;
  }
  return !!(candidate.id || candidate.phone || candidate.email || candidate.telegram || candidate.whatsapp || candidate.max);
}

/**
 * Фильтрует кандидатов для рассылки, возвращая валидных и количество пропущенных.
 */
export function filterCandidatesForMailing(candidates: MailingCandidate[], isHH: boolean) {
  const valid = candidates.filter(c => isValidForMailing(c, isHH));
  return { valid, skipped: candidates.length - valid.length };
}
